<template>
  <v-app>
    <v-system-bar v-if="esDesarrollo" dark height="35" color="red lighten-2">
      <v-spacer></v-spacer>DESARROLLO
      <v-spacer />
    </v-system-bar>
    <pedidos-boss-negocio-tiempo-real
      v-if="$store.getters['auth/role'] === 'boss_negocio'"
    />
    <v-snackbar v-model="snackbar" :color="snackbar_color" top>
      {{ snackbar_text }}
      <v-btn text @click="snackbar = false" color>Cerrar</v-btn>
    </v-snackbar>
    <dashboard-core-app-bar v-model="expandOnHover" />

    <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" />

    <dashboard-core-view />
  </v-app>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PedidosBossNegocioTiempoReal from "@/components/negocio/PedidosBossNegocioTiempoReal.vue";
export default {
  name: "DashboardIndex",

  components: {
    PedidosBossNegocioTiempoReal,
    DashboardCoreAppBar: () => import("@/components/admin/AppBar"),
    DashboardCoreDrawer: () => import("@/components/admin/Drawer"),
    DashboardCoreView: () => import("@/components/admin/View"),
  },

  data: () => ({
    expandOnHover: false,
  }),
  computed: {
    snackbar: {
      get() {
        return this.$store.state.snackbar.show;
      },
      set(value) {
        this.$store.commit("snackbar/reset");
      },
    },
    ...mapState({
      isLogged: (state) => state.auth.isLogged,
      isLoaded: (state) => state.loaded,
      snackbar_text: (state) => state.snackbar.text,
      snackbar_color: (state) => state.snackbar.color,
    }),
    ...mapGetters({
      esDesarrollo: "app/esDesarrollo",
    }),
  },
};
</script>
